import { Button, Grid2 } from '@mui/material'
import Checkbox from 'components/forms/Checkbox'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import { PGSSE_ENTITIES_TYPE } from 'installation/constants/InstallationConstants'
import moment from 'moment'
import React from 'react'
import { SANDRE } from 'referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import useSandreList from 'utils/customHook/useSandreList'

const PgsseSituationPanel = ({
    situationDate,
    setSituationDate = () => {},
    entityFilter = [],
    setEntityFilter = () => {},
    dangSitFilter = [],
    setDangSitFilter = () => {},
}) => {
    const installationDanger = useSandreList(SANDRE.INSTALLATIONS_DANGERS)

    const filterEntity = (check, type) => {
        const newEntityFilter = check ? [...entityFilter, type.code] : [...entityFilter.filter(d => d !== type.code)]
        setEntityFilter(newEntityFilter)
    }

    const filterDangerousSituation = (check, sandreCode) => {
        const newDangSitFilter = check ? [...dangSitFilter, sandreCode.code] : [...dangSitFilter.filter(d => d !== sandreCode.code)]
        setDangSitFilter(newDangSitFilter)
    }

    return (
        <Grid2 container style={{ paddingTop: '20px' }}>
            <Grid2 size={12} pl={1}>
                <SimpleDatePicker
                    value={situationDate}
                    id='situationDate'
                    label={i18n.situationDateDangers}
                    onChange={v => setSituationDate(v)}
                />
            </Grid2>
            <fieldset style={{ width: '100%', margin: '0 10px' }}>
                <legend>{i18n.type}</legend>
                <Grid2 container >
                    {PGSSE_ENTITIES_TYPE.map(type => {
                        return (
                            <Grid2
                                key={type.code}
                                size={12}
                                onClick={() => filterEntity(!entityFilter.includes(type.code), type)}
                            >
                                <Checkbox
                                    label={i18n[type.i18n]}
                                    checked={entityFilter.includes(type.code)}
                                />
                            </Grid2>
                        )
                    })}
                </Grid2>
            </fieldset>
            <fieldset style={{ width: '100%', margin: '0 10px' }}>
                <legend>{i18n.dangerousSituation}</legend>
                <Grid2 container >
                    {installationDanger.map(sandreCode => {
                        return (
                            <Grid2
                                key={sandreCode.code}
                                size={6}
                                onClick={() => filterDangerousSituation(!dangSitFilter.includes(sandreCode.code), sandreCode)}
                            >
                                <Checkbox
                                    label={sandreCode.name}
                                    checked={dangSitFilter.includes(sandreCode.code)}
                                />
                            </Grid2>
                        )
                    })}
                </Grid2>
            </fieldset>
            <Grid2 container justifyContent='flex-end' className='padding-1'>
                <Button
                    variant='contained'
                    color='primary'
                    onClick={() => {
                        setDangSitFilter([])
                        setEntityFilter([])
                        setSituationDate(moment.now())
                    }}
                >
                    {i18n.reinit}
                </Button>
            </Grid2>
        </Grid2>
    )
}

PgsseSituationPanel.propTypes = {
    situationDate: PropTypes.string,
    setSituationDate: PropTypes.func,
    entityFilter: PropTypes.shape([]),
    setEntityFilter: PropTypes.func,
    dangSitFilter: PropTypes.shape([]),
    setDangSitFilter: PropTypes.func,
}

export default PgsseSituationPanel
